import React, { useState } from "react";
import Modal from "../../../Common/Modal";
import Account from "../partials/account";
import { useDispatch } from "react-redux";
import { setActiveAccount } from "../../../../redux/actions/home/ActiveAccountAction";
import EmptyBeneficiaryIcon from "../../../Icons/EmptyBeneficiaryIcon";
import { SearchIcons } from "../../../Icons";

const SelectedAccountModal = ({ clientAccounts, activeAccount, children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  const handleOnCloseModal = () => {
    setIsModalOpen(false);
    setSearchTerm("");
  };

  const handleChangeAccount = async (account) => {
    await dispatch(setActiveAccount(account));
    setIsModalOpen(false);
    setSearchTerm("");
  };

  const filteredAccounts = clientAccounts.filter(
    (acc) =>
      acc.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      acc.account_number.includes(searchTerm),
  );

  return (
    <>
      <div onClick={() => setIsModalOpen(true)}>{children}</div>
      <Modal
        isOpen={isModalOpen}
        handleOnCloseModal={handleOnCloseModal}
        header={true}
        headerTitle={"Select Account"}
        className="selected-account-modal w-[432px] max-h-[578px] overflow-scroll hide-scrollbar"
      >
        <div className="flex flex-col px-6 max-[360px]:px-3 pb-6">
          {clientAccounts.length > 0 && (
            <div className="search-input-wrapper flex items-center px-4 py-2 rounded-xl mb-4 border border-divider">
              <SearchIcons className="w-4 h-4 text-text-secondary mr-2" />
              <input
                type="text"
                placeholder="Search your accounts..."
                className="search-input"
                onChange={(e) => setSearchTerm(e.target.value)}
                value={searchTerm}
              />
            </div>
          )}

          {filteredAccounts.length ? (
            filteredAccounts.map((account) => (
              <div
                key={account.id}
                onClick={() => handleChangeAccount(account)}
              >
                <Account
                  key={account.id}
                  {...account}
                  activeAccount={activeAccount}
                />
              </div>
            ))
          ) : (
            <div className="flex flex-col items-center justify-center py-6">
              <EmptyBeneficiaryIcon className="w-40 h-40" />
              <p className="empty-text">
                {searchTerm
                  ? `No accounts match "${searchTerm}"`
                  : "No account found"}
              </p>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default SelectedAccountModal;
